import { useState, useEffect } from 'react';
function getStorageValue(key, defaultValue) {
    const saved = localStorage.getItem(key);
    if (!saved)
        return defaultValue;
    try {
        const parsed = JSON.parse(saved);
        if (Date.now() > parsed.expiry) {
            localStorage.removeItem(key);
            return defaultValue;
        }
        return parsed.value;
    }
    catch {
        return defaultValue;
    }
}
export const useLocalStorage = (key, defaultValue, ttl) => {
    const [value, setValue] = useState(() => getStorageValue(key, defaultValue));
    useEffect(() => {
        if (!ttl) {
            localStorage.setItem(key, JSON.stringify({ value }));
            return;
        }
        const expiry = Date.now() + ttl;
        const item = { value, expiry };
        localStorage.setItem(key, JSON.stringify(item));
    }, [key, value, ttl]);
    return [value, setValue];
};
